<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',

  // components:{
  //   bid(){
  //       return this.$store.state.product.bid
  //   },
  //   pid(){
  //       return this.$store.state.product.pid
  //   },
  //   alphabet(){
  //       return this.$store.state.product.alphabet
  //   },
  //   keyword(){
  //       return this.$store.state.product.keyword
  //   },
  // },

  // watch:{
  //   bid(){
  //     console.log(this.$route)
  //       if(this.$route.name != 'home'){
  //           window.alert('nope')
  //           this.$router.push('/network')
  //           return
  //       }
  //   },
  //   pid(){
  //       if(this.$route.name != 'home'){
  //           this.$router.push('/network')
  //           return
  //       }
  //   },
  //   alphabet(){
  //       if(this.$route.name != 'home'){
  //           this.$router.push('/network')
  //           return
  //       }
  //   },
  //   keyword(){
  //       if(this.$route.name != 'home'){
  //           this.$router.push('/network')
  //           return
  //       }
  //   },
  // }
}
</script>

<style>
*{
  margin:0;
}
body{
  background: #EEEEEE;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #353F43;
  /* margin-top: 60px; */
}
@media screen and (max-width: 900px){
  body{
    background: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue